import React, { useState } from "react";
import { Box, PageTitle, Grid, Text } from "@flexisaf/flexibull2";
import { RiFeedbackLine } from "react-icons/ri";
import Theme from "../../theme";
import styled from "styled-components";
import { Input } from "@flexisaf/flexibull2/build/input";
import Unresolved from "./tabs/Unresolved";
import Resolved from "./tabs/Resolved";
import useFeedbackGet from "../../hooks/feedback/useFeedbackGet";

const Feedbacks = () => {
  const [activeTab, setActvieTab] = useState(0);
  const [resolved, setResolved] = useState(false);
  const {
    feedbacks,
    isLoading,
    pageOptions,
    totalElements,
    limit,
    setPage,
    page,
    setLimit,
    searchText,
    setSearchText,
    postFeedback,
    refetch,
  } = useFeedbackGet({
    questionId: "",
    resolved: resolved,
    issueType: resolved ? "" : "QUESTION",
  });

  const tabs = [
    {
      title: "Unresolved",
      content: (
        <Unresolved
          refetch={refetch}
          resolved={resolved}
          postFeedback={postFeedback}
          feedbacks={feedbacks}
          isLoading={isLoading}
          pageOptions={pageOptions}
          totalElements={totalElements}
          limit={limit}
          setPage={setPage}
          page={page}
          setLimit={setLimit}
        />
      ),
    },
    {
      title: "Resolved",
      content: (
        <Resolved
          feedbacks={feedbacks}
          isLoading={isLoading}
          pageOptions={pageOptions}
          totalElements={totalElements}
          limit={limit}
          setPage={setPage}
          page={page}
          setLimit={setLimit}
        />
      ),
    },
  ];

  const handleTabChange = (index) => {
    setActvieTab(index);
    setResolved(index === 0 ? false : true);
  };
  return (
    <Box>
      <PageTitle>
        <RiFeedbackLine size={25} style={{ position: "absolute" }} />

        <Text bold size={Theme.H3} style={{ padding: "10px 35px" }}>
          User Feedbacks
        </Text>
      </PageTitle>

      <Box>
        <Grid
          default="minmax(auto, 300px) repeat(4, minmax(auto, 100px))  "
          sm="1fr"
          gap="1rem"
        >
          <Input
            name="search feedback"
            placeholder="Search feedback"
            iconLeft="saf-search-normal"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Grid>
      </Box>

      <Box pad="1rem 0">
        <CustomTab>
          {tabs?.map((tab, index) => {
            return (
              <button
                className={index === activeTab ? "active" : ""}
                key={index}
                onClick={() => handleTabChange(index)}
              >
                {tab.title}
              </button>
            );
          })}
        </CustomTab>

        <Box pad="1rem 0">{tabs[activeTab].content}</Box>
      </Box>
    </Box>
  );
};

export default Feedbacks;

const CustomTab = styled.div`
  border-bottom: 1px solid lightgrey;
  button {
    border: none;
    padding: 8px 2px;

    cursor: pointer;
    background: none;
  }
  button:nth-child(2) {
    margin-left: 8px;
  }

  .active {
    border-bottom: 2px solid #1a7a97;
  }
`;
